import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { loginUser } from '@store/reducers/auth';
import { Button, Input } from '@components';
import { faUser, faLock } from '@fortawesome/free-solid-svg-icons';
import * as Yup from 'yup';
import * as AuthService from '../../services/auth';
import axios from '@utils/axios'


const Login = () => {
    const [isAuthLoading, setAuthLoading] = useState(false);
    const dispatch = useDispatch();

    const history = useHistory();
    const {t, i18n} = useTranslation();
    const [isBrFlag, setBrFlag] = useState(i18n.language == 'br');

    const login = async (username, password) => {
        try {
            setAuthLoading(true);
            let token = await AuthService.loginByLocal(username, password);
            toast.success(t('Login.Success'));
            dispatch(loginUser(token));
            axios.get('/api/systeminfo').then((res) => {
                if (res.data.data.fwVersion !== undefined) {
                    const product = res.data.data.product
                    localStorage.setItem('product', product)
                    localStorage.setItem('fwVersion', res.data.data.fwVersion)
                    localStorage.setItem('showSerialNumber',['G-1u','G-1u-Intr'].indexOf(product) != -1)
                    localStorage.setItem('showOLTAddress',['Chassi','G-1u-Intr'].indexOf(product) == -1)
                }
            }).catch((e) => { })
            setAuthLoading(false);
            history.push('/');
        } catch (error) {
            setAuthLoading(false);
            toast.error(error.message);
        }
    };

    const formik = useFormik({
        initialValues: {
            username: '',
            password: ''
        },
        validationSchema: Yup.object({
            username: Yup.string()
                .required(t('Login.Required')),
            password: Yup.string()
                .min(4, t('Login.Most4Chars'))
                .max(30, t('Login.Less30Chars'))
                .required(t('Login.Required'))
        }),
        onSubmit: (values) => {
            login(values.username, values.password);
        }
    });

    const onClickIdiom = (value) => {
        i18n.changeLanguage(value?'br':'en')
        setBrFlag(value)
    }

    document.getElementById('root').classList = 'hold-transition login-page';

    return (
        <div className="login-box">
            <div className="card card-outline card-primary">
                <div className="card-header text-center">
                    <img src="/img/logo.png" style={{ height: '100px' }} />
                </div>
                <div className="card-body">
                    <p className="login-box-msg">{t('Login.SignIn')}</p>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="mb-3">
                            <Input
                                icon={faUser}
                                placeholder={t('Login.Username')}
                                type="text"
                                formik={formik}
                                formikFieldProps={formik.getFieldProps('username')}
                            />
                        </div>
                        <div className="mb-3">
                            <Input
                                icon={faLock}
                                placeholder={t('Login.Password')}
                                type="password"
                                formik={formik}
                                formikFieldProps={formik.getFieldProps('password')}
                            />
                        </div>
                        <div className="d-flex justify-content-center">
                            <button type="button" className={"btn btn-default btn-flat mr-3 " + (isBrFlag?"active":"") } onClick={() => onClickIdiom(true)}>
                                <i className="flag-icon flag-icon-br"></i>
                            </button>
                            <button type="button" className={"btn btn-default btn-flat " + (isBrFlag?"":"active") } onClick={() => onClickIdiom(false)}>
                                <i className="flag-icon flag-icon-us"></i>
                            </button>
                        </div>
                        <div className="mb-3"></div>
                        <div className="row">
                            <div className="col-8">
                            </div>
                            <div className="col-4">
                                <Button
                                    block
                                    type="submit"
                                    isLoading={isAuthLoading}
                                >
                                    {t('Button.SignIn')}
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
